import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const displayTime = (value) =>
  value && moment(value).isValid() ? moment(value).format('HH:mm') : '—';

const fileLinks = (docs) => {
  if (!docs?.length) {
    return '—';
  }
  return (
    <>
      {docs.map((doc, index) => (
        <React.Fragment key={doc.id || index}>
          {index > 0 && ', '}
          <a href={doc.url} target='_blank' rel='noreferrer'>
            {doc.name || doc.file_name || doc.url}
          </a>
        </React.Fragment>
      ))}
    </>
  );
};

export const getRequestViewSections = (
  t,
  item,
  { titleTypes, statusTexts } = {},
) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Informazioni Generali'),
      fields: [
        {
          text: t('Outlet Village'),
          value: display(
            item['shopping_centers.title'] || item.company?.shopping_center?.title,
          ),
        },
        {
          text: t('Insegna'),
          value: display(item['companies.title'] || item.company?.title),
        },
        {
          text: t('Categoria richiesta'),
          value: display(titleTypes?.[item.type_event] || item.type_event),
        },
        {
          text: t('Data richiesta'),
          value: display(item.created_at),
        },
        {
          text: t('Data dal'),
          value: displayDate(item.date_from),
        },
        { text: t('Orario dalle'), value: displayTime(item.time_from) },
        {
          text: t('Data al'),
          value: displayDate(item.date_to),
        },
        { text: t('Orario alle'), value: displayTime(item.time_to) },
        {
          text: t('Nome richiedente in store'),
          value: display(item.staff),
        },
        {
          text: t('Telefono richiedente in store'),
          value: display(item.staff_phone),
        },
        {
          text: t('Descrizione'),
          value: display(item.work_description),
        },
        {
          text: t('Accesso personale esterno'),
          value: displayBool(item.external_personal_access, t),
        },
      ],
    },
    {
      title: t('Stato'),
      fields: [
        {
          text: t('Stato'),
          value: display(statusTexts?.[item.status] || item.status),
        },
        {
          text: t('Approvazione Direzione'),
          value: display(
            statusTexts?.[item.director_approved] || item.director_approved,
          ),
        },
      ],
    },
    {
      title: t('Allegato'),
      fields: [{ text: t('File'), value: fileLinks(item.docs) }],
    },
  ];
};
